import { COLORS } from '@btime/constants'
import { calcuatePercentageBasedOnTotal, formatDate } from '@btime/helpers'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { TableColumn } from '../../../../components/tables/Table'
import { Text } from '../../../../components/presentation/Text'
import { useFormSends } from '../_load/FormSendsLoader'
import DataTable from '../../../../packages/kiti/components/table/DataTable'
import ResendLink from '../ResendLink'

const FormSendsTable = () => {
  const { t } = useTranslation('listForms')
  const data = useFormSends()

  const columns = [
    {
      label: t('sendDate'),
      dataIndex: 'insertedAt',
      sortIndex: 'INSERTED_AT',
      flex: 2,
      render: value => (
        <TableColumn bold color={COLORS.dark2}>
          {formatDate('DD/MM/YYYY HH:mm', value)}
        </TableColumn>
      )
    },
    {
      label: t('invites'),
      dataIndex: 'sentCount',
      sortIndex: 'SENT_COUNT',
      flex: 1,
      render: (_, record) => <Text> {record.sentCount} </Text>
    },

    {
      label: t('replied'),
      dataIndex: 'repliesCount',
      sortIndex: 'REPLIES_COUNT',
      flex: 1,
      render: (_, record) => {
        return `${calcuatePercentageBasedOnTotal(record.repliesCount, record.sentCount)}%`
      }
    },
    {
      label: t('resend'),
      flex: 1,
      render: (_, record) => <ResendLink record={record} />
    }
  ]

  return <DataTable rowKey="id" columns={columns} data={data} inPanel size="medium" />
}

export default FormSendsTable
